// mermaid-init.js — bundle entry for dist/assets/mermaid-init.js.
//
// A separate bundle from pantarhei.js on purpose: it is only injected next to
// the mermaid library, on the pages that actually contain a diagram, so the
// main runtime stays free of diagram code. Rendering is idempotent (blocks are
// marked once handled), so loading it twice is harmless.

import { initMermaid } from './mermaid-render.js';

function run() {
    initMermaid();
}

if (typeof document !== 'undefined') {
    document.addEventListener('quarto:load', run);
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
}
